import type { IGraphQLQuery } from '@libs/graphQL/types'
import type {
  CreateHomeReportMutationArgs,
  CreateReportMutationArgs,
  DeleteReportMutationArgs,
  EditReportMutationArgs,
  Mutation
} from '../typeDefs/types'

export type MutationCreateReport = IGraphQLQuery<
  CreateReportMutationArgs,
  Pick<Mutation, 'createReport'>
>

export const mutationCreateReport = `
  mutation mutationCreateReport($report: InputCreateReport!) {
    createReport(
      report: $report
    ) {
      name
      type
      checkerIds
      directoryIds
      attackTypeIds
      profileId
      recipientEmails
      format
      csvSeparator
      dataTimeframe
      recurrence
      timeZone
    }
  }
`
export type MutationCreateHomeReport = IGraphQLQuery<
  CreateHomeReportMutationArgs,
  Pick<Mutation, 'createHomeReport'>
>

export const mutationScheduleHomeReport = `
  mutation MutationScheduleHomeReport($report: InputCreateHomeReport!) {
    createHomeReport(
      report: $report
    ) {
      name
      type
      recipientEmails
      format
      dataTimeframe
      recurrence
      timeZone
      profileId
    }
  }
`

export type MutationEditReport = IGraphQLQuery<
  EditReportMutationArgs,
  Pick<Mutation, 'editReport'>
>

export const mutationEditReport = `
  mutation mutationEditReport($report: InputEditReport!) {
    editReport(
      report: $report
    ) {
      id
      name
      type
      checkerIds
      directoryIds
      attackTypeIds
      profileId
      recipientEmails
      format
      csvSeparator
      dataTimeframe
      recurrence
      timeZone
    }
  }
`

export type MutationDeleteReport = IGraphQLQuery<
  DeleteReportMutationArgs,
  Pick<Mutation, 'deleteReport'>
>

export const mutationDeleteReport = `
  mutation mutationDeleteReport($report: InputDeleteReport!) {
    deleteReport(
      report: $report
    )
  }
`
